<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form #auroraSubmitForm="ngForm"
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-4 ps-0">
            <div class="unity-form-group" style="display: inline-block">
              <ep-selector
                label="Show"
                minButtonModeSize="lg"
                [values]="this.modelChild.quickFilterCodes"
                [(value)]="this.modelChild.showMode"
                (valueChange)="this.setShowMode(this.modelChild.showMode)"
              >
              </ep-selector>
            </div>
          </div>

          <div class="col-2">
            <div style="float: right; margin-top: var(--aurora-spacing-08)">
              <ep-document-import (allDocsComplete)="this.refreshAfterImport()"></ep-document-import>
            </div>
          </div>

          <ng-container *ngIf="this.modelChild.showMode == 'F'">
            <div class="col-6">
              <div class="unity-form-group" style="display: inline-block">
                <ep-selector
                  label="Filed Date"
                  minButtonModeSize="lg"
                  [values]="[
                    { Code: 'L30D', Code_Desc: 'Last 30 Days', Icon: '', Tooltip: 'Last 30 Days' },
                    { Code: 'L90D', Code_Desc: 'Last 90 Days', Icon: '', Tooltip: 'Last 90 Days' },
                    { Code: 'ANYTIME', Code_Desc: 'Anytime', Icon: '', Tooltip: 'Anytime' }
                  ]"
                  [(value)]="this.modelChild.filedDateRangeCode"
                  (valueChange)="
                    dsCollection.criteria.Filed_Date_From = app.getCodedDate(
                      this.modelChild.filedDateRangeCode,
                      'BEGIN'
                    );
                    dsCollection.criteria.Filed_Date_To = app.getCodedDate(this.modelChild.filedDateRangeCode, 'END');
                    model.dirty = true
                  "
                >
                </ep-selector>
              </div>
            </div>

            <div class="col-12">
              <div class="unity-form-group" style="display: inline-block">
                <label for="Doc_Name">Doc Name</label>
                <input
                  type="text"
                  name="Doc_Name"
                  [(ngModel)]="dsCollection.criteria.Desc"
                  ngControl="Doc_Name"
                  (valueChange)="model.dirty = true"
                />
              </div>
            </div>

            <div class="col-4">
              <div class="unity-form-group select" style="display: inline-block">
                <label for="Doc_Class">Doc Class</label>
                <ep-dropdown
                  class="unity-form-row w-100"
                  name="Doc_Class"
                  codeSet="DocClass"
                  [(ngModel)]="dsCollection.criteria.Doc_Class"
                  (ngModelChange)="model.dirty = true"
                  [nullValue]="{ Code: '', Code_Desc: 'All Classes' }"
                ></ep-dropdown>
              </div>
            </div>

            <div class="col-4">
              <div class="unity-form-group select" style="display: inline-block">
                <label for="File_Drawer">File Drawer</label>
                <ep-dropdown
                  class="unity-form-row w-100"
                  name="File_Drawer"
                  class="form-control"
                  codeSet="FileDrawer"
                  [(ngModel)]="dsCollection.criteria.File_Drawer"
                  (ngModelChange)="model.dirty = true"
                  [nullValue]="{ Code: '', Code_Desc: 'All Drawers' }"
                ></ep-dropdown>
              </div>
            </div>

            <div class="col-4">
              <div class="unity-form-group select" style="display: inline-block">
                <label for="File_Folder">File Folder</label>
                <ep-dropdown
                  class="unity-form-row w-100"
                  name="File_Folder"
                  codeSet="FileFolder"
                  [(ngModel)]="dsCollection.criteria.File_Folder"
                  (ngModelChange)="model.dirty = true"
                  [nullValue]="{ Code: '', Code_Desc: 'All Folders' }"
                ></ep-dropdown>
              </div>
            </div>

            <div class="col-4">
              <div class="unity-form-group select" style="display: inline-block">
                <label for="Role_Type">Role Type</label>
                <ep-dropdown
                  class="unity-form-row w-100"
                  name="Role_Type"
                  codeSet="RoleType"
                  [(ngModel)]="dsCollection.criteria.Role_Type"
                  [nullValue]="{ Code: '', Code_Desc: 'Any Role' }"
                  (ngModelChange)="
                    dsCollection.criteria.Entity_ID = null; this.modelChild.Entity_Name = ''; model.dirty = true
                  "
                ></ep-dropdown>
              </div>
            </div>

            <div class="col-6">
              <div class="unity-form-group" style="display: inline-block">
                <label for="Entity_ID">Entity</label>
                <ep-inline-search
                  [noLabel]="true"
                  class="w-100"
                  name="Entity_ID"
                  [(desc)]="modelChild.Entity_Name"
                  [(ngModel)]="dsCollection.criteria.Entity_ID"
                  [descFormControlPath]="'modelChild.Entity_Name'"
                  [formControlPath]="'dsCollection.criteria.Entity_ID'"
                  [objectType]="'entity'"
                  [placeholder]="'Select Entity'"
                  [isStandalone]="true"
                  [criteria]="{ Role_Type: dsCollection.criteria.Role_Type }"
                  [options]="{ autoSearch: true, allowClear: true }"
                  (ngModelChange)="model.dirty = true"
                  (dataSelected)="entitySelected($event)"
                >
                </ep-inline-search>
              </div>
            </div>

            <div class="col-6">
              <div class="unity-form-group" style="display: inline-block">
                <label for="Contract_ID">Contract</label>
                <ep-inline-search
                  [noLabel]="true"
                  class="w-100"
                  name="Contract_ID"
                  [(desc)]="modelChild.Contract_Num"
                  [(ngModel)]="dsCollection.criteria.Contract_ID"
                  [descFormControlPath]="'modelChild.Contract_Num'"
                  [formControlPath]="'dsCollection.criteria.Contract_ID'"
                  [objectType]="'contract'"
                  [placeholder]="'Select Contract'"
                  [isStandalone]="true"
                  [criteria]="{
                    Contract_Set_Status: 'ALL',
                    Range: 'All',
                    Revision_Mode: 'ALL',
                    Contract_Num_Mode: 'BeginsWith'
                  }"
                  [options]="{ autoSearch: false, allowClear: true }"
                  (ngModelChange)="dsCollection.criteria.Contract_Scope = 'Rev'; model.dirty = true"
                >
                </ep-inline-search>
              </div>
            </div>
            <div class="col-6">
              <div class="unity-form-group" style="display: inline-block">
                <label for="Claim_ID">Claim</label>
                <ep-inline-search
                  [noLabel]="true"
                  class="w-100"
                  name="Claim_ID"
                  [(desc)]="modelChild.Claim_Num"
                  [(ngModel)]="dsCollection.criteria.Claim_ID"
                  [descFormControlPath]="'modelChild.Claim_Num'"
                  [formControlPath]="'dsCollection.criteria.Claim_ID'"
                  [objectType]="'claim'"
                  [placeholder]="'Select Claim'"
                  [isStandalone]="true"
                  [options]="{ autoSearch: false, allowClear: true }"
                  [criteria]="{}"
                  (ngModelChange)="model.dirty = true"
                >
                </ep-inline-search>
              </div>
            </div>

            <div class="col-3">
              <div class="unity-form-group" style="display: inline-block">
                <label for="Creation_Date_From">Created From</label>
                <ep-date-input
                  [noLabel]="true"
                  name="Creation_Date_From"
                  [(ngModel)]="dsCollection.criteria.Creation_Date_From"
                  (ngModelChange)="model.dirty = true"
                  [maxDate]="dsCollection.criteria.Creation_Date_To"
                ></ep-date-input>
              </div>
            </div>
            <div class="col-3">
              <div class="unity-form-group" style="display: inline-block">
                <label for="Creation_Date_To">Created To</label>
                <ep-date-input
                  [noLabel]="true"
                  name="Creation_Date_To"
                  [(ngModel)]="dsCollection.criteria.Creation_Date_To"
                  (ngModelChange)="model.dirty = true"
                  [minDate]="dsCollection.criteria.Creation_Date_From"
                ></ep-date-input>
              </div>
            </div>

            <div class="col-3">
              <div class="unity-form-group" style="display: inline-block">
                <label for="Sent_Date_From">Sent From</label>
                <ep-date-input
                  [noLabel]="true"
                  name="Sent_Date_From"
                  [(ngModel)]="dsCollection.criteria.Sent_Date_From"
                  (ngModelChange)="model.dirty = true"
                  [maxDate]="dsCollection.criteria.Sent_Date_To"
                ></ep-date-input>
              </div>
            </div>
            <div class="col-3">
              <div class="unity-form-group" style="display: inline-block">
                <label for="Sent_Date_To">Sent To</label>
                <ep-date-input
                  [noLabel]="true"
                  name="Sent_Date_To"
                  [(ngModel)]="dsCollection.criteria.Sent_Date_To"
                  (ngModelChange)="model.dirty = true"
                  [minDate]="dsCollection.criteria.Sent_Date_From"
                ></ep-date-input>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="this.modelChild.showMode == 'U'">
            <div class="col-6">
              <div class="unity-form-group" style="display: inline-block">
                <ep-selector
                  label="Creation Date"
                  minButtonModeSize="lg"
                  [values]="[
                    { Code: 'L30D', Code_Desc: 'Last 30 Days', Icon: '', Tooltip: 'Last 30 Days' },
                    { Code: 'L90D', Code_Desc: 'Last 90 Days', Icon: '', Tooltip: 'Last 90 Days' },
                    { Code: 'ANYTIME', Code_Desc: 'Anytime', Icon: '', Tooltip: 'Anytime' }
                  ]"
                  [(value)]="this.modelChild.createdDateRangeCode"
                  (valueChange)="
                    dsCollection.criteria.Creation_Date_From = app.getCodedDate(
                      this.modelChild.createdDateRangeCode,
                      'BEGIN'
                    );
                    dsCollection.criteria.Creation_Date_To = app.getCodedDate(
                      this.modelChild.createdDateRangeCode,
                      'END'
                    );
                    model.dirty = true
                  "
                >
                </ep-selector>
              </div>
            </div>
            <div class="col-8">
              <div class="unity-form-group" style="display: inline-block">
                <ep-selector
                  label="Assigned Filing User"
                  minButtonModeSize="lg"
                  [values]="[
                    {
                      Code: 'CURRENTUSER',
                      Code_Desc: 'Me',
                      Icon: '',
                      Tooltip: 'Filing assigned to Me'
                    },
                    { Code: '', Code_Desc: 'Anyone', Icon: '', Tooltip: 'Filing assigned to Anyone' }
                  ]"
                  [(value)]="dsCollection.criteria.Filing_User_ID"
                  (valueChange)="model.dirty = true"
                >
                </ep-selector>
              </div>
            </div>
          </ng-container>

          <div class="col-12">
            <aurora-button
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              variant="primary"
              (click)="auroraSubmitForm.onSubmit($event)"
            >
              Search
            </aurora-button>
            <aurora-button
              class="pull-right margin-l-5"
              type="button"
              (click)="this.setShowMode(this.modelChild.showMode)"
              style="margin-top: 16px"
              variant="secondary"
            >
              Reset
            </aurora-button>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #documentFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table
            class="table table-select table-fixed-header"
            style="max-width: 1500px; min-width: 1150px; overflow-x: scroll"
          >
            <tr
              *ngIf="dsCollection.objectNodes && dsCollection.objectNodes.length > 0 && dsCollection.status == 'Ready'"
            >
              <th>Document Name</th>
              <th>Creation Date</th>
              <th>Doc Class</th>
              <th *ngIf="this.modelChild.showMode == 'F' || this.modelChild.showMode == 'P'">Filed By</th>
              <th *ngIf="this.modelChild.showMode == 'U'">Assigned Filer</th>
            </tr>
            <tr
              *ngFor="
                let document of dsCollection.objectNodes
                  | epFilter : documentFilter.filter : documentFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(document)"
            >
              <td style="width: 500px">
                {{ document.Doc_Name }}
              </td>
              <td style="width: 150px">
                {{ document.Created_By.Date | epDate : 'mm/dd/yyyy hh:mm' }}
              </td>
              <td style="width: 200px">
                {{ document.Doc_Class_Desc }}
              </td>
              <td>
                <span *ngIf="document.Filing_User && document.Filing_User.Entity_Name">
                  {{ document.Filing_User.Entity_Name }}
                </span>
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Documents</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
